<template>
  <icon-font :type="type" />
</template>

<script>
import { Icon } from "ant-design-vue";
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_3178977_dfxmeh4mreu.js", //"//at.alicdn.com/t/font_3178977_pso2dwc8oeb.js",
});
export default {
  components: {
    IconFont,
  },
  props: ["type"],
};
</script>
